import React from "react";

/**
 * @component CalendarImportIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CalendarImportIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CalendarImportIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CalendarImportIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 1.5V3h7.5V1.5h1.5V3H15a1.5 1.5 0 011.5 1.5v3.75H15v-1.5H3V15h6v1.5H3A1.5 1.5 0 011.5 15V4.5A1.5 1.5 0 013 3h.75V1.5h1.5z"
      />
      <path d="M12.75 13.5v3h1.5v-3h2.25l-3-3-3 3h2.25z" />
    </svg>
  )
);
CalendarImportIcon.displayName = "CalendarImportIcon";
export default CalendarImportIcon;
